import actions from './actions';

const {
  PRODUCT_ADD_BEGIN,
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_ERR,

  PRODUCT_UPDATE_BEGIN,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_ERR,

  PRODUCT_READ_BEGIN,
  PRODUCT_READ_SUCCESS,
  PRODUCT_READ_ERR,


  PRODUCT_DELETE_BEGIN,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_ERR,



} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const singlepersoninitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: null,
  loading: false,
  error: null
}

const PRODUCTReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PRODUCT_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PRODUCT_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PRODUCT_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};



const PRODUCTAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PRODUCT_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PRODUCT_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PRODUCT_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};



const PRODUCTUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {

    case PRODUCT_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PRODUCT_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PRODUCT_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const PRODUCTDeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case PRODUCT_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PRODUCT_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export {
  PRODUCTAddReducer,
  PRODUCTUpdateReducer,
  PRODUCTReducer,
  PRODUCTDeleteReducer


};
